// extracted by mini-css-extract-plugin
module.exports = {"ActiveQuiz":"lxUZJWset1GI2zs-KMYd0","Question":"Flw_yoS8PUw9j2u08Dbiu"};